import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToOrdinal',
  standalone: false
})
export class NumberToOrdinalPipe implements PipeTransform {
  transform(value?: number): string {
    if (value == null) {
      return $localize`:@@common.message.notSpecified:Not Specified`;
    }
    
    let suffix: string;
    if (value % 100 >= 11 && value % 100 <= 13) {
      suffix = $localize`:@@common.afterFirstOrdinalSuffix:th`;
    } else if (value % 10 === 1) {
      suffix = value === 1
        ? $localize`:@@common.firstOrdinalSuffix:st`
        : $localize`:@@common.afterFirstOrdinalSuffix:st`;
    } else if (value % 10 === 2) {
      suffix = $localize`:@@common.afterFirstOrdinalSuffix:nd`;
    } else if (value % 10 === 3) {
      suffix = $localize`:@@common.afterFirstOrdinalSuffix:rd`;
    } else {
      suffix = $localize`:@@common.afterFirstOrdinalSuffix:th`;
    }

    return `${value}${suffix}`;
  }
}
